/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualWorkingCapitalDto } from '../../models/backend-actual-working-capital-dto';

export interface MonitoringActualsWorkingCapitalRetrieve$Params {
  id: number;
}

export function monitoringActualsWorkingCapitalRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsWorkingCapitalRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsWorkingCapitalRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualWorkingCapitalDto>;
    }),
  );
}

monitoringActualsWorkingCapitalRetrieve.PATH = '/api/monitoring/actuals/working-capital/{id}/';
